import axios from "axios";
import qs from "qs";
import { GATEWAY_URL } from "../config";

export class ApiService {
  constructor(apiPath) {
    const sharedConfig = {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    };
    const axiosConfig = {
      baseURL: apiPath,
      ...sharedConfig,
    };
    const axiosConfigV1 = {
      baseURL: `${apiPath}/v1`,
      ...sharedConfig,
    };
    if (process.env.NODE_ENV === "development") {
      axiosConfig.headers["x-forwarded-host"] = "www.dynahealth.com";
    }
    this.baseRequests = axios.create(axiosConfig);
    this.requestsV1 = axios.create(axiosConfigV1);
  }

  initErrorHandling = (callback) => {
    const interceptorBase = this.baseRequests.interceptors.response.use(
      undefined,
      () => {
        callback();
      }
    );
    const interceptorV1 = this.requestsV1.interceptors.response.use(
      undefined,
      () => {
        callback();
      }
    );
    return () => {
      this.baseRequests.interceptors.response.eject(interceptorBase);
      this.requestsV1.interceptors.response.eject(interceptorV1);
    };
  };

  async getDrugs(startsWith) {
    return (
      await this.requestsV1.get("/drugs", {
        params: { startsWith },
      })
    ).data;
  }

  async getSpecialtyDetails(specialtyId, type) {
    return await this.requestsV1.get(`/specialties/${specialtyId}`, {
      params: { type },
    });
  }

  async getSpecialties(type) {
    return await this.requestsV1.get(`/specialties`, {
      params: { type },
    });
  }

  async followSpecialty(apiPath, feedId, subscriptionType) {
    return await this.requestsV1.post(apiPath, {
      feedId,
      subscriptionType,
    });
  }
  async deleteFollowSpecialty(specialtyId, feedId) {
    return await this.requestsV1.delete(`/specialties/${specialtyId}/follow`, {
      data: {
        feedId,
      },
    });
  }

  async getDrugInteractionsViewModel() {
    return await this.requestsV1.get(`/drug-interactions`);
  }

  async acceptPolicy(apiPath) {
    return await this.requestsV1.post(apiPath, { policyAccepted: true });
  }

  async getDrugNameSuggestions(url, term) {
    const query = qs.stringify({ term });
    return await this.requestsV1.get(`${url}?${query}`);
  }

  async getDrugInteractionsMonograph(apiPath) {
    return await this.requestsV1.get(apiPath);
  }

  async getDrugInteractionResults(apiPath, drugs) {
    return await this.requestsV1.post(apiPath, { drugs });
  }

  async getViewmodel(slug, startsWith) {
    return await this.baseRequests.get(
      `/viewmodel/${slug}${startsWith ? `?startsWith=${startsWith}` : ""}`
    );
  }

  async getBrowse(browsePath, params) {
    const queryParams = qs.stringify(params);

    if (queryParams) {
      return (
        await this.baseRequests.get(`/view-model/${browsePath}?${queryParams}`)
      ).data;
    }

    return (await this.baseRequests.get(`/view-model/${browsePath}`)).data;
  }
}

const apiService = new ApiService(`${GATEWAY_URL}/api/browse`);
export default apiService;
